import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import {
  Box,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { appImages } from "../../assets";
import GlobalButton from "../button";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AlternateEmailRoundedIcon from "@mui/icons-material/AlternateEmailRounded";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const EducationCityDetailCard = ({ data, handleApply }) => {
  return (
    <Grid
      container
      sx={{
        padding: { xs: 1, sm: 2 },
        borderRadius: 2.5,
        backgroundColor: "text.white",
        // cursor: "pointer",
        boxShadow:
          "0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.1)",
        border: "1px solid #f5f5f5",
      }}
    >
      <Grid item xs={12} md={4}>
        <CardMedia
          component="img"
          image={appImages.business2Img}
          sx={{
            height: { xs: "100%", md: "300px" },
            width: { xs: "100%", md: "100%" },
            borderRadius: "8px",
            flexShrink: 0,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardContent sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom noWrap>
            ABCD Public School
          </Typography>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <LocalPhoneIcon sx={{ fontSize: "1rem" }} />
            <Typography variant="body1" color="text.mediumGray" noWrap>
              Call : 123-456-789
            </Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <EmailOutlinedIcon sx={{ fontSize: "1rem" }} />
            <Typography variant="body1" color="text.mediumGray" noWrap>
              Email: abcd@gmail.com
            </Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <AlternateEmailRoundedIcon sx={{ fontSize: "1rem" }} />
            <Typography variant="body1" color="text.mediumGray" noWrap>
              Address: abcd@gmail.com
            </Typography>
          </Stack>
          <Typography variant="body1" fontWeight={600} mt={2}>
            Details
          </Typography>
          <Typography variant="body1" color="text.mediumGray">
            Welcome to ABCD Public School where education meets excellence. We
            offer a diverse range of programs designed to inspire and challenge
            students, empowering them to reach their full potential.
          </Typography>

          <Box mt={1}>
            <Typography
              variant="body1"
              color={"primary.main"}
              fontWeight={600}
              mt={2}
            >
              Admission Fee : 100 to 2k USD
            </Typography>
            <Stack direction={"row"} alignItems={"center"} gap={1} mt={1}>
              <MessageOutlinedIcon />
              <FacebookOutlinedIcon />
              <WhatsAppIcon />
              <LinkedInIcon />
            </Stack>
          </Box>
        </CardContent>
      </Grid>
      <Grid item xs={12} md={2}>
        <CardActions
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Rating defaultValue={3} />
          <Stack direction={"column"} gap={2}>
            <GlobalButton
              btnText={"Application Request"}
              handleClickBtn={handleApply}
              styleProps={{
                width: { xs: "100%", md: "150px" },
                backgroundColor: "text.coralRed",
              }}
            />
            <GlobalButton
              btnText={"Prospectus PDF"}
              styleProps={{
                width: { xs: "100%", md: "150px" },
                backgroundColor: "text.coralRed",
              }}
            />
          </Stack>
        </CardActions>
      </Grid>
    </Grid>
  );
};

export default EducationCityDetailCard;
